<template>
  <div
    class="card-container appoint-visit-form car-info"
    :class="{ 'modal-mode': modalMode === 'logged-in' }"
  >
    <form class="top-wrapper">
      <standard-select
        label-text="Wersja silnikowa"
        :arrow-color="buttonColor"
        @selected="onEngineSelected($event)"
        :options="availableEngines"
        :value="engineValue"
        :show-kw="true"
        required
        :option-name="['capacity', 'engine', 'power', 'quattro']"
      />
      <standard-select
        label-text="Typ skrzyni biegów"
        :arrow-color="buttonColor"
        @selected="onTransmissionSelected($event)"
        :value="transmissionValue"
        :options="availableTransmissions"
        required
        :option-name="['transmission']"
      />
      <standard-select
        label-text="Typ przeglądu"
        :arrow-color="buttonColor"
        @selected="onInpectionTypeSelected($event)"
        :value="inspectionTypeValue"
        :options="availableInspectionTypes"
        required
        :option-name="['inspectionType']"
        :disabled="!disableSelect"
        :dictionary="true"
        name="inspectionType"
      />
      <div v-if="showCheckbox">
        <input
          class="standard-checkbox"
          type="checkbox"
          name="checkbox"
          :disabled="disableCheckbox"
          v-model="checkboxLPGValue"
        >
        <label for="checkbox">
          Instalacja LPG
        </label>
      </div>
    </form>
    <div class="bottom-wrapper">
      <standard-button
        text="Dalej"
        custom-class="next-button"
        @buttonClick="next()"
        :disabled="disableButton"
      />
    </div>
    <step-indicator :step="2" />
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import StandardSelect from '~/StandardSelect';
import StepIndicator from '~/StepIndicator';
import { mapGetters, mapActions } from 'vuex';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';
import orderBy from 'lodash/orderBy';
import cloneDeep from 'lodash/cloneDeep';

// refactor is needed for the whole filtering functionality

export default {
  components: {
    StandardButton,
    StandardSelect,
    StepIndicator,
  },
  data() {
    return {
      engineValue: '',
      transmissionValue: '',
      inspectionTypeValue: '',
      disableSelect: false,
      inspectionTypeDictionary: {
        qg0: 'Standardowy okres obsługi',
        qg1: 'Zmienny okres przeglądu',
        qg2: 'Stały okres obsługi',
        qi4: 'Stały okres wymiany oleju',
        qi6: 'Zmienny okres wymiany oleju',
      },
      checkboxLPGValue: false,
      showCheckbox: false,
      disableCheckbox: false,
    };
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      buttonColor: 'brand/getThirdColor',
      chosenCarSpecs: 'car/getChosenCarSpecs',
      modalMode: 'modal/getModalMode',
      filteredCars: 'car/getFilteredCars',
      filters: 'car/getFilters',
      allCars: 'brand/getSpecificModels',
      authStatus: 'auth/getAuthStatus',
    }),
    withLogin() {
      return this.authStatus.loggedIn;
    },
    availableEngines() {
      const engines = this.getSelectOptions({ model: this.filters.model }, ['capacity', 'engine', 'power', 'quattro']);
      return orderBy(uniqWith(engines, isEqual), ['capacity']);
    },
    availableTransmissions() {
      const filters = cloneDeep(this.filters);
      delete filters.inspectionType;
      delete filters.transmission;

      return this
        .getSelectOptions(filters, ['transmission'])
        .filter((obj, pos, arr) => arr.map(mapObj => mapObj.transmission).indexOf(obj.transmission) === pos);
    },
    availableInspectionTypes() {
      const filters = cloneDeep(this.filters);
      delete filters.inspectionType;
      delete filters.hasLPG;

      const inspectionTypes = this.getSelectOptions(filters, ['inspectionType']);

      return uniqWith(inspectionTypes, isEqual)
        .filter(item => item.inspectionType !== '')
        .map(item => ({
          ...item,
          name: this.inspectionTypeDictionary[item.inspectionType],
        }));
    },
    disableButton() {
      if (!this.disableSelect) {
        return !this.engineValue.length || !this.transmissionValue.length;
      }
      return !this.engineValue.length || !this.transmissionValue.length || !this.inspectionTypeValue.length;
    },
  },
  methods: {
    ...mapActions({
      chooseCar: 'car/chooseCar',
      closeModal: 'modal/closeModal',
      setModalStep: 'modal/setModalStep',
      searchForChosenCarName: 'car/searchForChosenCarName',
      setFilters: 'car/setFilters',
      filterCars: 'car/filterCars',
      setTransmission: 'car/setTransmission',
      setEngine: 'car/setEngine',
      setCapacity: 'car/setCapacity',
      setPower: 'car/setPower',
      setLPG: 'car/setLPG',
      setQuattro: 'car/setQuattro',
      setInspectionType: 'car/setInspectionType',
      setModalContent: 'modal/setContent',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedVin: 'visit/setSelectedVin',
      setMileage: 'visit/setMileage',
    }),
    getSelectOptions(filters, map) {
      return this.allCars.filter((car) => {
        /* eslint-disable */
        for (const filter in filters) {
          if (filters[filter] !== '' && filters[filter] != car[filter]) {
            return false;
          }
        }
        /* eslint-enable */
        return true;
      }).map((car) => {
        const obj = {};
        for (const prop in car) {
          if (map.includes(prop)) {
            obj[prop] = car[prop];
          }
        }
        return obj;
      });
    },
    parseFilters(value, keys) {
      let parsedFilters = [];

      value.split(' ').forEach((v, i) => {
        parsedFilters = [...parsedFilters, { type: keys[i], value: v }];
      });

      return parsedFilters;
    },
    onEngineSelected(value) {
      const parsedValue = value.replace(' KW', '');
      const engineKeys = ['capacity', 'engine', 'power', 'quattro'];
      const parsedFilters = this.parseFilters(parsedValue, engineKeys);
      const quattroFilter = parsedFilters.find(filter => filter.type === 'quattro');
      this.engineValue = parsedValue;

      const filters = [];
      engineKeys.forEach((key) => {
        if (key === 'quattro') {
          filters.push({ type: 'quattro', value: !!(quattroFilter !== undefined && quattroFilter.value) });
        } else {
          filters.push({ type: key, value: parsedFilters.find(filter => filter.type === key).value });
        }
      });
      this.setFilters(filters);

      Promise.all([
        this.setCapacity(parsedFilters[0].value),
        this.setEngine(parsedFilters[1].value),
        this.setPower(parsedFilters[2].value),
        this.setQuattro(filters[3].value),
      ]).then(() => {
        this.inspectionTypeValue = '';

        if (this.availableTransmissions.length) {
          this.setTransmission(this.availableTransmissions[0].transmission)
            .then(() => {
              setTimeout(() => {
                this.transmissionValue = this.availableTransmissions[0].transmission;
              }, 0);
            });
        }

        this.setInspectionType('')
          .then(() => {
            setTimeout(() => {
              this.inspectionTypeValue = '';
            }, 0);
          });
      });


      this.resetLPGFilter();
    },
    resetVisitSpecs() {
      this.setSelectedPartner(null);
      this.setSelectedServices(null);
      this.setSelectedVisitDate(null);
      this.setRegisteredVisit(null);
      this.setMileage(0);
    },
    onTransmissionSelected(value) {
      const transmissionKeys = ['transmission'];
      this.transmissionValue = value;
      this.setTransmission(value);
      this.setFilters(this.parseFilters(value, transmissionKeys));

      this.setInspectionType('')
        .then(() => {
          setTimeout(() => {
            this.inspectionTypeValue = '';
          }, 0);
        });

      this.resetLPGFilter();
    },
    onInpectionTypeSelected(value) {
      const parsedValue = Object.keys(this.inspectionTypeDictionary).find(key => this.inspectionTypeDictionary[key] === value);
      this.inspectionTypeValue = value;
      this.setInspectionType(parsedValue);
      this.setFilters({ type: 'inspectionType', value: parsedValue });

      this.resetLPGFilter();
    },
    next() {
      if (this.modalMode === 'logged-out') {
        this.closeModal();
        this.resetVisitSpecs();
        this.$router.push({ path: '/no_auth/visit/station' });
        this.searchForChosenCarName()
          .then(() => {
            this.setSelectedCarModelID(this.chosenCarSpecs.id);
            this.setSelectedLicensePlate(this.chosenCarSpecs.licensePlate);
            this.setSelectedVin(this.chosenCarSpecs.vin);
          });
      } else {
        this.setModalStep('third_step');
        this.searchForChosenCarName();
      }
    },
    setVariabled() {
      const {
        transmission, engine, capacity, power,
      } = this.chosenCarSpecs;
      if (transmission && engine && capacity && power) {
        this.engineValue = `${capacity} ${engine} ${power}`;
        this.transmissionValue = transmission;
      }
    },
    handleKeyDown(event) {
      const { keyCode } = event;

      if (keyCode === 13 && (this.engineValue.length && this.transmissionValue.length)) {
        this.next();
      }

      if (keyCode === 8) {
        this.setModalStep('first_step');
      }
    },
    filterAllCars() {
      const {
        model, engine, transmission, power, capacity, inspectionType,
      } = this.chosenCarSpecs;
      return this.allCars.filter(carObj => carObj.model.toLowerCase() == model.toLowerCase()
          && (engine === '' || carObj.engine == engine)
          && carObj.transmission == transmission
          && carObj.power == power
          && carObj.capacity == capacity
          && (inspectionType === '' || carObj.inspectionType == inspectionType));
    },
    resetLPGFilter() {
      this.checkboxLPGValue = false;
      this.setLPG('');
      this.setFilters({ type: 'hasLPG', value: '' });
    },
  },
  watch: {
    availableInspectionTypes: {
      handler() {
        if (this.engineValue) {
          this.disableSelect = !!this.availableInspectionTypes.length;
        }
      },
      deep: true,
    },
    filters: {
      handler(newVal, oldVal) {
        const filteredCars = this.filterAllCars();
        const containsAll = (arr1, arr2) => arr1.every(i => arr2.includes(i));

        this.showCheckbox = containsAll([true], filteredCars.map(car => car.hasLPG));

        if (this.showCheckbox && filteredCars.length === 1) {
          this.checkboxLPGValue = true;
          this.disableCheckbox = true;
        } else {
          this.disableCheckbox = false;
        }

        this.searchForChosenCarName();
      },
      deep: true,
    },
    checkboxLPGValue(newVal, oldVal) {
      this.setLPG(newVal);
      this.setFilters({ type: 'hasLPG', value: newVal });
    },
  },
  mounted() {
    this.setVariabled();
    this.setModalContent({
      title: !this.withLogin ? 'Umów się na wizytę' : 'Dodaj samochód',
      subtitle: 'Podaj parametry Twojego samochodu',
    });

    document.addEventListener('keydown', this.handleKeyDown, false);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
